import { stats } from '@/mocks/homepage';

export default function StatsSection() {
  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto">
          {stats.map((stat) => (
            <div key={stat.label} className="flex flex-col items-center text-center p-4">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-3">
                <i className={`${stat.icon} text-xl`}></i>
              </div>
              <div className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-1">
                {stat.value}
              </div>
              <div className="text-sm text-foreground-500">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}